import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'

export default function useFilterToggleTag() {
  const store = useStore()
  const route = useRoute()
  const router = useRouter()

  const updateRoute = () => {
    const page = computed(() => store.state['collection/page'])
    const selectedFilters = computed(() => store.getters['collection/getSelectedFilters'])
    const searchQuery = computed(() => store.state['collection/searchQuery'])
    let query = { ...selectedFilters.value, page: page.value }
    // if (page.value == 1) {
    //   delete query.page
    // }
    if (searchQuery.value) {
      query.q = searchQuery.value
    }
    router.replace({ path: route.path, query: query })
  }

  const toggleTag = async tagId => {
    await store.dispatch('collection/toggleTag', tagId)
    updateRoute()
  }

  return { toggleTag }
}
